import { Container, Grid, Stack } from '@mui/material';
import pluralize from 'pluralize';
import React from 'react';

import { useFolded2025Data } from '~components/business-owner/Folded2025/hooks/useFolded2025Data';

import styles from './Folded2025Machines.module.scss';

import CoinIcon from '../../assets/icons/Coin.svg?react';
import MachinesIcon from '../../assets/Machines_Icon.svg?react';
import Folded2025Card from '../Folded2025Card';
import Folded2025Title from '../Folded2025Title';

const Folded2025Machines = (): JSX.Element => {
	const { data } = useFolded2025Data();

	const isPoundsProcessedVisible =
		(data?.summary?.machines?.total_pounds_processed || 0) > 0;

	return (
		<div className={styles.container}>
			<Container disableGutters>
				<Folded2025Title icon={<MachinesIcon />}>Machines</Folded2025Title>

				<Grid container spacing={2}>
					{isPoundsProcessedVisible && (
						<Grid item xs={12} md={4}>
							<Folded2025Card>
								<Folded2025Card.Value>
									{Number(
										data?.summary?.machines?.total_pounds_processed,
									).toLocaleString()}{' '}
									lbs
								</Folded2025Card.Value>
								<Folded2025Card.Label>
									Approx. lbs through machines
								</Folded2025Card.Label>
							</Folded2025Card>
						</Grid>
					)}
					<Grid item xs={12} md={isPoundsProcessedVisible ? 8 : 12}>
						<Folded2025Card>
							<Grid container spacing={4}>
								<Grid item xs={12} md={4}>
									<Folded2025Card.Value>
										{Number(
											data?.summary?.machines?.total_turns,
										).toLocaleString()}
									</Folded2025Card.Value>
									<Folded2025Card.Label>
										Total machine
										{' ' +
											pluralize(
												'turn',
												data?.summary?.machines?.total_turns,
											)}
									</Folded2025Card.Label>
								</Grid>

								<Grid item xs={12} md={4}>
									<Folded2025Card.Value>
										{Number(
											data?.summary?.machines?.washer_turns,
										).toLocaleString()}
									</Folded2025Card.Value>
									<Folded2025Card.Label>
										Washers
										{' ' +
											pluralize(
												'turn',
												data?.summary?.machines?.washer_turns,
											)}
									</Folded2025Card.Label>
								</Grid>

								<Grid item xs={12} md={4}>
									<Folded2025Card.Value>
										{Number(
											data?.summary?.machines?.dryer_turns,
										).toLocaleString()}
									</Folded2025Card.Value>
									<Folded2025Card.Label>
										Dryer
										{' ' +
											pluralize(
												'turn',
												data?.summary?.machines?.dryer_turns,
											)}
									</Folded2025Card.Label>
								</Grid>
							</Grid>
						</Folded2025Card>
					</Grid>
					{(data?.summary?.machines?.quarters_saved?.total_quarters || 0) >
						0 && (
						<Grid item xs={12}>
							<Folded2025Card icon={<CoinIcon />}>
								<Grid
									container
									spacing={2}
									sx={{
										alignItems: 'center',
										justifyContent: 'space-between',
									}}
								>
									<Grid item xs={12} md={4}>
										<Folded2025Card.Value>
											{
												data?.summary?.machines?.quarters_saved
													?.total_quarters
											}
										</Folded2025Card.Value>
										<Folded2025Card.Label>
											Coin collection saved
										</Folded2025Card.Label>
									</Grid>
									<Grid item xs={12} md={8}>
										<Folded2025Card.Label>
											Payments through your reader helped to avoid
											collecting
											{' ' +
												data?.summary?.machines?.quarters_saved
													?.total_quarters}{' '}
											quarters. Your lower back thanks you!
										</Folded2025Card.Label>
									</Grid>
								</Grid>
							</Folded2025Card>
						</Grid>
					)}
					{data?.summary?.machines?.most_popular_days.length && (
						<Grid item xs={12} md={4}>
							<Folded2025Card>
								<Folded2025Card.Value>
									{
										data?.summary?.machines?.most_popular_days[0]
											.day_of_week
									}
								</Folded2025Card.Value>
								<Folded2025Card.Label>
									Most popular visit day
								</Folded2025Card.Label>
							</Folded2025Card>
						</Grid>
					)}
					<Grid item xs={12} md={4}>
						<Folded2025Card>
							<Folded2025Card.Value>
								{data?.summary?.machines?.fan_favorite?.machine_name}
							</Folded2025Card.Value>
							<Folded2025Card.Label>Most used machine</Folded2025Card.Label>
						</Folded2025Card>
					</Grid>
					<Grid item xs={12} md={4}>
						<Folded2025Card>
							<Folded2025Card.Value>
								{
									data?.summary?.machines?.star_players
										?.machine_group_name
								}
							</Folded2025Card.Value>
							<Folded2025Card.Label>
								Most used machine type
							</Folded2025Card.Label>
						</Folded2025Card>
					</Grid>
				</Grid>
			</Container>
		</div>
	);
};

export default Folded2025Machines;
